<template lang="pug">
v-menu(
  top
  offset-y
  ref="folioMenu"
  v-model="dialog"
  transition="slide-y-transition"
  :nudge-top="5"
  :close-on-content-click="false")
  template(v-slot:activator="{ on, attrs }")
    v-btn(
      color="primary"
      fab
      large
      dark
      :title="`${dialog ? 'Cerrar' : 'Ver herramientas'}`"
      bottom
      fixed
      right
      v-bind="attrs"
      v-on="on")
      v-icon {{ dialog ? 'mdi-window-close' : 'mdi-hammer-wrench' }}
  v-list(dense)
    v-subheader(class="text-h6")
      | Folio: <b class="ml-2">{{ currentFolio.numero_matricula }}</b>
    v-divider
    //- MENU COLINDANCIA
    v-subheader(v-if="menu === 'adjacency'")
      v-icon(@click="menu = 'main'") mdi-arrow-left
      | Opciones Colindancia
    v-list-item-group(v-if="menu === 'adjacency'")
      v-list-item(
        :disabled="currentFolio.codigo_catastral === ''"
        @click="adjacencySearch('code', currentFolio.codigo_catastral, matchDatabase)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral === '' ? 'grey' : 'blue'") mdi-numeric-1-box
        v-list-item-content
          v-list-item-title Código Catastral
      v-list-item(
        :disabled="currentFolio.codigo_catastral_antiguo === ''"
        @click="adjacencySearch('code', currentFolio.codigo_catastral_antiguo, matchDatabase)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral_antiguo === '' ? 'grey' : 'blue'"
          ) mdi-numeric-2-box
        v-list-item-content
          v-list-item-title Código Catastral Anterior
          v-divider
    //- MENU COMPARACION CATASTRAL
    v-subheader(v-if="menu === 'comparison'")
      v-icon(@click="menu = 'main'") mdi-arrow-left
      | Opciones Comparación
    v-list-item-group(v-if="menu === 'comparison'")
      v-list-item(
        :disabled="currentFolio.codigo_catastral === ''"
        @click="comparisonSearch('code', currentFolio.codigo_catastral)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral === '' ? 'grey' : 'blue'") mdi-numeric-1-box
        v-list-item-content
          v-list-item-title Código Catastral
      v-list-item(
        :disabled="currentFolio.codigo_catastral_antiguo === ''"
        @click="comparisonSearch('code', currentFolio.codigo_catastral_antiguo)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral_antiguo === '' ? 'grey' : 'blue'"
          ) mdi-numeric-2-box
        v-list-item-content
          v-list-item-title Código Catastral Anterior
    //- MENU CATASTRAL
    v-subheader(v-if="menu === 'cadastral'")
      v-icon(@click="menu = 'main'") mdi-arrow-left
      | Buscar en Bases Catastrales
    v-list-item-group(v-if="menu === 'cadastral'")
      v-list-item(
        :disabled="currentFolio.codigo_catastral === ''"
        @click="cadastralSearch('code', currentFolio.codigo_catastral)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral === '' ? 'grey' : 'blue'") mdi-numeric-1-box
        v-list-item-content
          v-list-item-title Código Catastral
      v-list-item(
        :disabled="currentFolio.codigo_catastral_antiguo === ''"
        @click="cadastralSearch('code', currentFolio.codigo_catastral_antiguo)"
        :title="`Buscar: ${currentFolio.codigo_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.codigo_catastral_antiguo === '' ? 'grey' : 'blue'"
          ) mdi-numeric-2-box
        v-list-item-content
          v-list-item-title Código Catastral Anterior
      v-list-item(
        :disabled="currentFolio.cedula_catastral === ''"
        @click="cadastralSearch('code', currentFolio.cedula_catastral)"
        :title="`Buscar: ${currentFolio.cedula_catastral}`")
        v-list-item-icon
          v-icon(
            :color="currentFolio.cedula_catastral === '' ? 'grey' : 'blue'"
          ) mdi-numeric-3-box
        v-list-item-content
          v-list-item-title Cédula Catastral
      v-list-item(
        :disabled="currentFolio.numero_matricula === ''"
        @click="cadastralSearch('fmi', currentFolio.numero_matricula)")
        v-list-item-icon
          v-icon(
            :color="currentFolio.numero_matricula === '' ? 'grey' : 'blue'"
          ) mdi-numeric-4-box
        v-list-item-content
          v-list-item-title Matrícula Inmobiliaria
    v-list-item-group(v-if="menu === 'main'")
      v-list-item(@click="menu = 'cadastral'")
        v-list-item-icon
          v-icon(color="blue") mdi-earth-arrow-right
        v-list-item-content
          v-list-item-title Bases Catastrales
      v-list-item(
        @click="menu = 'adjacency'"
        title="Permite encontrar los predios colindantes")
        v-list-item-icon
          v-icon(color="pink") mdi-land-plots-circle
        v-list-item-content
          v-list-item-title Colindancia catastral
      v-list-item(
        @click="menu = 'comparison'"
        title="Permite comparar polígono del predio en bases catastrales")
        v-list-item-icon
          v-icon(color="amber") mdi-compare
        v-list-item-content
          v-list-item-title Comparación catastral
      v-list-item(@click="generateFamily('')")
        v-list-item-icon
          v-icon(color="green") mdi-family-tree
        v-list-item-content
          v-list-item-title Familia Registral
      v-list-item(
        v-if="$route.name === 'FolioDetail'"
        @click="analysisFolio(currentFolio.id)")
        v-list-item-icon
          v-icon(color="teal") mdi-scale-balance
        v-list-item-content
          v-list-item-title Análisis Jurídico
      v-list-item(
        v-if="$route.name === 'FolioAnalysis'"
        @click="detailFolio(currentFolio.id)")
        v-list-item-icon
          v-icon(color="teal") mdi-file-certificate-outline
        v-list-item-content
          v-list-item-title Información principal
      v-list-item(@click="showBotttomPdf('', '')")
        v-list-item-icon
          v-icon(color="red") mdi-file-pdf-box
        v-list-item-content
          v-list-item-title Ver PDF
      v-list-item(@click="downloadPdf('', '')")
        v-list-item-icon
          v-icon(color="red") mdi-file-download
        v-list-item-content
          v-list-item-title Descargar PDF
      v-list-item(
        title="Permite actualizar la información del folio"
        @click="syncFolio"
        :disabled="loadingFolio")
        v-list-item-icon
          v-icon(color="purple") mdi-sync-circle
        v-list-item-content
          v-list-item-title
            | {{ loadingFolio ? 'Sincronizando...' : 'Sincronizar Folio'}}
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import folioMixin from '@/mixins/folioMixin.js';

export default {
  name: 'FolioTools',

  mixins: [folioMixin],

  data () {
    return {
      // propiedad que indica el estado del menu
      dialog: false,
      // propieda que indica el menu actual de herramientas
      menu: 'main',
    }
  },

  computed: {
    ...mapState('folios', ['currentFolio', 'loadingFolio']),
    matchDatabase() {
      if (this.currentFolio === null) return '';
      const bases = this.currentFolio.bases_consultadas;
      if (bases === null) return '';
      if (!('match_database' in bases)) return '';
      return bases.match_database !== '' ? bases.match_database : '';
    },
  },

  watch: {
    menu: {
      handler() {
        this.$nextTick(() => {
        this.$refs.folioMenu && this.$refs.folioMenu.updateDimensions();
      });
      }
    }
  },

  methods: {
    ...mapMutations('ui', ['SHOW_BOTTOM_MODAL', 'SHOW_SNACKBAR']),
    ...mapActions('folios', ['getFolioDetail']),
    
    // metodo para sincronizar el folio sin ercarga completa de la pagina
    async syncFolio() {
      await this.getFolioDetail(this.currentFolio.id);
    }
  }
};
</script>